module.exports = __webpack_public_path__ + "static/media/oberflex-cheneanoeuds-1200x2490.73bd25cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneanoeuds-1200x2490.jpg
// module id = 994
// module chunks = 37